import { useSuspenseQuery } from '@tanstack/react-query';
import type { ItemType } from '@outdoria/types';
import { fetcher } from '../utils';
import { ITEM_TYPES_ALL } from '../queryKeys';

export const useGetItemTypesAll = () => {
  const getAllItemTypes = async (): Promise<ItemType[]> => {
    const res = await fetcher(`/v2/item_types`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<ItemType[], unknown, ItemType[], string[]>({
    queryKey: ITEM_TYPES_ALL,
    queryFn: getAllItemTypes,
  });

  return { data, isLoading, isFetched, isError };
};
